module.exports = __webpack_public_path__ + "img/DSCF0265.88403aaf.png";